import { render, staticRenderFns } from "./broadlist.vue?vue&type=template&id=0f3b2842&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./broadlist.vue?vue&type=style&index=0&id=0f3b2842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b2842",
  null
  
)

export default component.exports